import React from "react";
import { ReactComponent as ChevronRight } from "../assets/icons/chevron-right.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/search.svg";

interface IProps {
  onActionButtonClick: () => void;
  action?: string;
}

const TableActionButton = ({ onActionButtonClick, action }: IProps) => {
  return (
    <button
      className="flex table-action"
      type="button"
      onClick={onActionButtonClick}
    >
      {action === "Delete" ? <DeleteIcon /> : <ChevronRight />}
    </button>
  );
};

export default TableActionButton;
